// The domains used to filter topics and categories.
export const ValidityDomains = {
    market: 'market',
    model: 'model',
    structureWeek: 'structure-week',
    gearboxes: 'gearbox',
    propulsion: 'propulsion',
    electricCapacity: 'electric-capacity',
    electricPowertrain: 'electric-powertrain',
} as const;

// Type containing the values of the ValidityDomains object. E.g. "market" | "structure-week" ...
export type ValidityDomainValues = typeof ValidityDomains[keyof typeof ValidityDomains];

// Dictionary type with keys from ValidityDomainValues and values as string arrays.
export type AllValidityDomainsDto = {
    [K in ValidityDomainValues]: string[];
};